if (window.location.href.includes("pages/tov-rewards")) {
  var BonCrispTargetNode = document;
  var BonCrispObserverOptions = {
    childList: true,
    attributes: true,
    attributeFilter: ["data-id"],
    subtree: true, //Omit or set to false to observe only changes to the parent node.
  };

  function BonScrispObsCallback(mutationList, observer) {
    mutationList.forEach((mutation) => {
      if (mutation.type == "childList") {
        var addedNodes = mutation.addedNodes;
        for (x = 0; x < addedNodes.length; x++) {
          var aNode = addedNodes[x];

          if (aNode.tagName == "SCRIPT") {
            // check script content
            if (
              aNode.getAttribute("src") &&
              aNode.getAttribute("src").includes("mulberry-integration.js")
            ) {
              aNode.setAttribute("type", "text");
            }
          }
        }
      }
    });
  }

  var BonCrispObserver = new MutationObserver(BonScrispObsCallback);
  BonCrispObserver.observe(BonCrispTargetNode, BonCrispObserverOptions);
}